<template>
  <div class="pa-2">
    <v-card class="pa-4 rounded-xl" flat outlined>
      <v-switch
        v-model="computedValue.requireLogin"
        class="ma-0"
        label="ورود کاربر"
        messages="با فعال کردن این گزینه، هر کاربر ابتدا باید با شماره خود ورود کند."
      />
    </v-card>
    <v-col class="pa-2" cols="12" v-if="computedValue.requireLogin">
      <v-card-title class="pb-0">عکس صفحه ورود</v-card-title>
      <pic-selector
        :key="computedValue.image + Date.now()"
        :default-cat-name="$t('login')"
        :edit-name="false"
        :field.sync="computedValue.image"
        one-pic
        single
      />
    </v-col>
  </div>
</template>

<script>
import picSelector from "../../../../components/UploadCenter/picSelector.vue";
export default {
  props: {
    value: { type: Object, default: () => ({}) },
  },
  components: {
    picSelector,
  },
  data() {
    return {};
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>

<style scoped></style>
